import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/common";
import { LoginPage, RegisterPage, ForgotPage, ResetPage } from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Generator from "./pages/Generator";
import Library from "./pages/Library";
import Links from "./pages/Links";
import Campaigns from "./pages/Campaigns";
import CalendarPage from "./pages/CalendarPage";
import Goals from "./pages/Goals";
import Commissions from "./pages/Commissions";
import Plans from "./pages/Plans";
import Integrations from "./pages/Integrations";
import Profile from "./pages/Profile";
import Suppliers from "./pages/Suppliers";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#09090B]"><Spinner /></div>;
  return user ? children : <Navigate to="/entrar" replace />;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#09090B]"><Spinner /></div>;
  return user ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/entrar" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/cadastro" element={<PublicOnly><RegisterPage /></PublicOnly>} />
            <Route path="/recuperar-senha" element={<ForgotPage />} />
            <Route path="/redefinir-senha" element={<ResetPage />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="produtos" element={<Products />} />
              <Route path="gerador" element={<Generator />} />
              <Route path="fornecedores" element={<Suppliers />} />
              <Route path="biblioteca" element={<Library />} />
              <Route path="links" element={<Links />} />
              <Route path="campanhas" element={<Campaigns />} />
              <Route path="calendario" element={<CalendarPage />} />
              <Route path="metas" element={<Goals />} />
              <Route path="comissoes" element={<Commissions />} />
              <Route path="planos" element={<Plans />} />
              <Route path="integracoes" element={<Integrations />} />
              <Route path="perfil" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
